import { useState } from 'react';

export default function useGroupForm() {
  const [newGroup, setNewGroup] = useState('');
  const [selectedGroup, setSelectedGroup] = useState<number>();

  const updateNewGroupField = (e) => {
    if (e.target.value.length <= 30) setNewGroup(e.target.value);
  };

  return {
    newGroup,
    setNewGroup,
    selectedGroup,
    setSelectedGroup,
    updateNewGroupField,
  };
}
